import { createSlice } from '@reduxjs/toolkit'

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: {
        value: [],
    },
    reducers: {
        addNotification: (state, action) => {
            const dataItem = action.payload;

            const newNotification = {
                "key": dataItem.key,
                "type": dataItem.type,
                "text": dataItem.text
            };

            state.value.push(newNotification);
        },
        removeNotification: (state, action) => {
            let notifications = state.value;

            notifications = notifications.filter(function (value, index, arr) {
                if (value.key === action.payload) {
                    return false;
                }

                return true;
            });

            state.value = notifications;
        },
    },
})

export const { addNotification, removeNotification } = notificationsSlice.actions

export default notificationsSlice.reducer